import { httpCall } from "@/common/util";
import appConstants from "@/config/appConstants";

export const fetchOrgAccessUsersIds = (params) => {
  return httpCall({
    method: appConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: `/1.0/organization/access/users`,
    data: params
  });
}

export const fetchOrgAccessUsersList = (params) => {
  let url = `/2.0/user/list`;
  if (params && params._query) {
    url += `?${params._query}`;
  }
  return httpCall({
    method: appConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url,
  });
};

export const searchOrgUsers = (params) => {
  let url = `/2.0/user/list`;
  if (params && params._query) {
    url += `?${params._query}`;
  }
  return httpCall({
    method: appConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url,
  });
};

export const provideOrgAccess = (params) => {
  return httpCall({
    method: appConstants.httpMethod.POST,
    headers: { "Content-Type": "application/json" },
    url: `/1.0/organization/access`,
    data: params
  });
};

export const removeOrgAccess = (params) => {
  return httpCall({
    method: appConstants.httpMethod.DELETE,
    headers: { "Content-Type": "application/json" },
    url: `/1.0/organization/access`,
    data: params
  });
}
